import { 
    FETCH_ALL_CONTRACTS,
    FETCH_ALL_CONTRACTS_SUCCESS,
    FETCH_ALL_CONTRACTS_FAILED,
  } from "../actions/types";
  
  export const INITIAL_STATE = {
    contracts:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ALL_CONTRACTS:
        return {
          ...state,
          loading:true
        };
      case FETCH_ALL_CONTRACTS_SUCCESS:
        return {
          ...state,
          contracts:action.payload,
          loading:false
        };
      case FETCH_ALL_CONTRACTS_FAILED:
        return {
          ...state,
          contracts:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };